import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ToolsContent from "../Components/ToolsContent";
import { useLocation, useNavigate } from "react-router-dom";
import { Beforeunload } from "react-beforeunload";
import logo from "../Assets/castlelogo.png";
import TicketCanvas from "../Components/ticketCanvas";
import "@cloudscape-design/global-styles/index.css";
import dayjs from "dayjs";

import {
  AppLayout,
  Calendar,
  ContentLayout,
  Header,
  SpaceBetween,
  Container,
  Grid,
  Form,
  FormField,
  Button,
  Input,
  Multiselect,
  RadioGroup,
  Flashbar,
  Icon,
  Box,
  Textarea,
  Modal,
  Table,
} from "@cloudscape-design/components";

import {
  Layout,
  //Button,
  //Form,
  //Input,
  Badge,
  Radio,
  Select,
  Typography,
  Space,
  Card,
  Row,
  Col,
  Alert,
  notification,
  DatePicker,
  TimePicker,
  Menu,
} from "antd";

import {
  ArrowRightOutlined,
  MenuOutlined,
  PieChartOutlined,
  ContainerOutlined,
  MailOutlined,
  DashboardOutlined,
  PicLeftOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";

const { Header: HeaderAnt, Sider, Content } = Layout;
const { TextArea } = Input;
const { Title } = Typography;
const { Option } = Select;

function TicketGenerator() {
  const navigate = useNavigate();
  const handleMenuClick = (e) => {
    navigate(e.key); // e.key will be your route path
  };
  const authIDToken = localStorage.getItem("idToken");
  process.env.NODE_ENV === "development"
    ? (document.title = "HS DEV MODE | Ticket Generator")
    : (document.title = "Ticket Generator | Hansoftware");
  const [responseSuccessful, setResponseSuccessful] = useState("");
  const [flashbarSuccess, setFlashbarSuccess] = useState([]);
  const [flashbarFail, setFlashbarFail] = useState([]);
  const [ticketLoading, setTicketLoading] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  // Validation
  const [errEta, setErrEta] = useState();
  const [errPlumbers, setErrPlumbers] = useState();
  const [errEstJobTime, setErrEstJobTime] = useState();
  const [errPaymentType, setErrPaymentType] = useState();
  const [errStatus, setErrStatus] = useState();
  const [errZipCode, setErrZipCode] = useState();
  const [errGate, setErrGate] = useState();
  const [errPhone, setErrPhone] = useState();
  const [errEmail, setErrEmail] = useState();
  const [gateCodeWarning, setGateCodeWarning] = useState();

  const [ticketData, setTicketData] = useState({
    callDate: null,
    jobDate: null,
    eta: "",
    name: "",
    address: "",
    zipCode: "",
    unitNum: "",
    community: "",
    gateCode: "",
    phoneNum: "",
    email: "",
    jobType: "Service Call",
    customJobType: "",
    customJobLabel: "Custom (type below)",
    plumberSelected: false,
    selectedPlumbers: [],
    estJobTime: "",
    paymentType: "",
    calendarDesc: "",
    calendarStatus: "Scheduled",
    jobNotes1: "",
    jobNotes2: "",
    jobNotes3: "",
    jobNotes4: "",
    jobNotes5: "",
    jobNotes6: "",
    jobNotes7: "",
    comments1: "",
    comments2: "",
  });

  const updateField = (field, value) => {
    setTicketData((prev) => ({ ...prev, [field]: value }));
  };

  const [autofillNotes, setAutofillNotes] = useState("");

  useEffect(() => {
    completeAutofill();
  }, []);

  const handleCallDateChange = (date, dateString) => {
    updateField("callDate", dateString);
  };
  const handleJobDateChange = (date, dateString) => {
    updateField("jobDate", dateString);
  };

  // validate data with errors
  const validateEta = (eta) => {
    if (!eta) {
      setErrEta("Required for job type");
    } else if (eta.length > 0 && !eta.match(/^[0-9\s:-]+$/)) {
      setErrEta("Please use only numbers, dashes and colons");
    } else {
      setErrEta(false);
    }
  };
  const validatePlumbers = (plumbers) => {
    if (ticketData.plumberSelected && plumbers < 1) {
      setErrPlumbers("You must choose at least one plumber");
    } else if (!ticketData.plumberSelected && plumbers < 1) {
      setErrPlumbers("You must choose at least one plumber");
    } else {
      setErrPlumbers(false);
    }
  };
  const validateEstJobTime = (estJobTime) => {
    if (
      estJobTime.length > 0 &&
      !estJobTime.match(/^\d+(\.5)?(-\d+(\.5)?)? hrs?$/i)
    ) {
      setErrEstJobTime("Please use only numbers, dashes and decimals");
      return true;
    } else {
      setErrEstJobTime(false);
      return false;
    }
  };
  const validatePaymentType = (paymentType) => {
    if (!paymentType) {
      setErrPaymentType("You must choose one option");
    } else {
      setErrPaymentType(false);
    }
  };
  const validateStatus = (status) => {
    if (!status) {
      setErrStatus("You must choose one option");
    } else {
      setErrStatus(false);
    }
  };
  const validateZipCode = (zipCode) => {
    if (zipCode.length > 0 && zipCode.length !== 5) {
      setErrZipCode("Too many characters. Please confirm correct zip code.");
    } else if (zipCode.length > 0 && !zipCode.match(/^\d+$/)) {
      setErrZipCode("Please confirm zip code matches example format.");
    } else if (!zipCode) {
      setErrZipCode("Required for job type");
    } else {
      setErrZipCode(false);
    }
  };
  const validateGate = (gate) => {
    if (gate.length > 10) {
      setErrGate(
        "Too many characters. Please only include the code and reserve extras for the Office Comments.",
      );
      return true;
    } else if (gate.toLowerCase() === "no gate") {
      setErrGate("Please leave blank if no gate code.");
      return true;
    } else {
      setErrGate(false);
      return false;
    }
  };
  const validatePhone = (phoneNum) => {
    if (1 > phoneNum.length > 12) {
      setErrPhone("Too many characters. Please confirm correct phone number");
    } else if (
      phoneNum.length > 0 &&
      !phoneNum.match(/^[0-9]{3}[-]?[0-9]{3}[-]?[0-9]{4}$/)
    ) {
      setErrPhone("Confirm phone number matches example format");
    } else {
      setErrPhone(false);
    }
  };
  const validateEmail = (email) => {
    if (
      email.length > 0 &&
      !email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
    ) {
      setErrEmail("Please make sure email address is correct.");
    } else {
      setErrEmail(false);
    }
  };

  const clearInputs = () => {
    setTicketData({
      callDate: null,
      jobDate: null,
      eta: "",
      name: "",
      address: "",
      zipCode: "",
      unitNum: "",
      community: "",
      gateCode: "",
      phoneNum: "",
      email: "",
      jobType: "Service Call",
      customJobType: "",
      customJobLabel: "Custom (type below)",
      plumberSelected: false,
      selectedPlumbers: [],
      estJobTime: "",
      paymentType: "",
      calendarDesc: "",
      calendarStatus: "Scheduled",
      jobNotes1: "",
      jobNotes2: "",
      jobNotes3: "",
      jobNotes4: "",
      jobNotes5: "",
      jobNotes6: "",
      jobNotes7: "",
      comments1: "",
      comments2: "",
    });
    setAutofillNotes("");
    clearErrs();
  };

  const clearErrs = () => {
    setErrEmail("");
    setErrEstJobTime("");
    setErrEta("");
    setErrPaymentType("");
    setErrStatus("");
    setErrPhone("");
    setErrPlumbers("");
    setErrZipCode("");
  };

  const checkInputs = () => {
    var errors = [];
    if (
      ticketData.jobType === "Service Call" ||
      ticketData.jobType === "Add-on"
    ) {
      validateEta(ticketData.eta);
      validatePlumbers(ticketData.selectedPlumbers);
      validatePaymentType(ticketData.paymentType);
      validateStatus(ticketData.calendarStatus);
      validateZipCode(ticketData.zipCode);
      validatePhone(ticketData.phoneNum);
      validateEmail(ticketData.email);
      if (
        !ticketData.callDate ||
        !ticketData.jobDate ||
        !ticketData.name ||
        !ticketData.address
      ) {
        errors.push("Date, name, and/or address is blank");
      }
      if (errEta !== false) errors.push("Time frame (ETA)");
      if (errPlumbers !== false) errors.push("Plumber(s) assigned");
      if (errPaymentType !== false) errors.push("Payment type");
      if (errStatus !== false) errors.push("Status");
      if (errZipCode !== false) errors.push("Zip code");
      if (errPhone !== false) errors.push("Phone number");
      if (errEmail !== false) errors.push("Email address");
    }
    if (ticketData.jobType === "Job View") {
      validateEta(ticketData.eta);
      validatePlumbers(ticketData.selectedPlumbers);
      validateZipCode(ticketData.zipCode);
      validatePhone(ticketData.phoneNum);
      validateEmail(ticketData.email);
      if (
        !ticketData.callDate ||
        !ticketData.jobDate ||
        !ticketData.name ||
        !ticketData.address
      ) {
        errors.push("Date, name, and/or address is blank");
      }
      if (errEta !== false) errors.push("Time frame (ETA)");
      if (errPlumbers !== false) errors.push("Plumber(s) assigned");
      if (errZipCode !== false) errors.push("Zip code");
      if (errPhone !== false) errors.push("Phone number");
      if (errEmail !== false) errors.push("Email address");
    }
    if (ticketData.jobType === "Product") {
      validatePlumbers(ticketData.selectedPlumbers);
      if (!ticketData.callDate || !ticketData.jobDate || !ticketData.name) {
        errors.push("Date, name, and/or address is blank");
      }
      if (errPlumbers !== false) errors.push("Plumber(s) assigned");
    }
    if (
      ticketData.jobType === ticketData.customJobType &&
      ticketData.jobType !== ""
    ) {
      if (ticketData.zipCode.length > 0) validateZipCode(ticketData.zipCode);
      if (ticketData.phoneNum.length > 0) validatePhone(ticketData.phoneNum);
      if (ticketData.email.length > 0) validateEmail(ticketData.email);
      if (errZipCode !== false) errors.push("Zip code");
      if (errPhone !== false) errors.push("Phone number");
      if (errEmail !== false) errors.push("Email address");
    }
    if (errors.length > 0) {
      return errors;
    } else {
      return true;
    }
  };

  const { state } = useLocation();
  const completeAutofill = () => {
    if (state) {
      if (state.from === "job-board") {
        completeEditTicket();
      } else {
        let data = state.e;
        //console.log(data);

        // today's date function
        var today = new Date();
        var dd = String(today.getDate());
        var mm = String(today.getMonth() + 1);
        var yy = today.getFullYear().toString().slice(-2);
        today = mm + "/" + dd + "/" + yy;

        let splitNames = data.customer_name.replaceAll(" ", "").split(",");
        let formattedName = `${splitNames[1]} ${splitNames[0]}`;
        if (formattedName.includes("(NateHerman)")) {
          formattedName = formattedName.replace("(NateHerman)", "");
        }
        if (data.isChild) {
          formattedName = formattedName.replace(/-\d/, ""); // remove "-1", "-2", etc due to child address
        }

        let plumbers = data.plumber;
        let newSelectedPlumbers = [];
        let newPlumberSelected = false;
        if (plumbers.length >= 1) {
          // split by commas, remove whitespace
          let plumberArr = plumbers.split(",");
          let trimmed = plumberArr.map((plumber) => plumber.trim());
          let newArr = [];
          trimmed.forEach((plumber) => {
            let bruh = {};
            if (plumber === "Bill") {
              bruh = {
                label: "Bill Hanson",
                value: "BH",
              };
            } else if (
              plumber === "ES" ||
              plumber === "Ed" ||
              plumber === "Eddy"
            ) {
              bruh = {
                label: "Ed Skillen",
                value: "ES",
              };
            } else if (plumber === "Jake") {
              bruh = {
                label: "Jake Hanson",
                value: "JH",
              };
            }
            newArr.push(bruh);
          });
          newSelectedPlumbers = newArr;
          newPlumberSelected = true;
        } else {
          newSelectedPlumbers = [];
          newPlumberSelected = false;
        }

        updateField("selectedPlumbers", newSelectedPlumbers);
        updateField("plumberSelected", newPlumberSelected);

        updateField("callDate", today);
        updateField("name", formattedName);
        updateField("address", data.service_address);
        updateField("zipCode", data.zipCode);
        updateField("unitNum", data.unit);
        updateField("community", data.community);
        updateField("gateCode", data.gate);
        updateField("phoneNum", data.phone_number);
        updateField("email", data.email);
        setAutofillNotes(data.notes);
      }
    }
  };

  const completeEditTicket = () => {
    let data = state.ticketData.ticket;
    let desc = state.ticketData.desc;
    updateField("calendarDesc", desc);
    let status = state.ticketData.status;
    updateField("calendarStatus", status);

    // today's date function
    var today = new Date();
    var dd = String(today.getDate());
    var mm = String(today.getMonth() + 1);
    var yy = today.getFullYear().toString().slice(-2);
    today = mm + "/" + dd + "/" + yy;

    let splitNames = data.name.replaceAll(" ", "").split(",");
    let formattedName = `${splitNames[1]} ${splitNames[0]}`;
    if (formattedName.includes("(NateHerman)")) {
      formattedName = formattedName.replace("(NateHerman)", "");
    }
    if (ticketData.isChild) {
      formattedName = formattedName.replace(/-\d/, ""); // remove "-1", "-2", etc due to child address
    }

    let plumbers = data.plumbers;
    let newSelectedPlumbers = [];
    let newPlumberSelected = false;
    if (plumbers.length >= 1) {
      // split by commas, remove whitespace
      let plumberArr = plumbers.split(",");
      let trimmed = plumberArr.map((plumber) => plumber.trim());
      let newArr = [];
      trimmed.forEach((plumber) => {
        let bruh = {};
        if (plumber === "Bill") {
          bruh = {
            label: "Bill Hanson",
            value: "BH",
          };
        } else if (plumber === "ES" || plumber === "Ed" || plumber === "Eddy") {
          bruh = {
            label: "Ed Skillen",
            value: "ES",
          };
        } else if (plumber === "Jake") {
          bruh = {
            label: "Jake Hanson",
            value: "JH",
          };
        }
        newArr.push(bruh);
      });
      newSelectedPlumbers = newArr;
      newPlumberSelected = true;
    } else {
      newSelectedPlumbers = [];
      newPlumberSelected = false;
    }

    //updateField("selectedPlumbers", newSelectedPlumbers);
    //updateField("plumberSelected", newPlumberSelected);

    updateField("callDate", data.callDate);
    updateField("jobDate", data.jobDate);
    updateField("name", data.name);
    updateField("address", data.address);
    updateField("zipCode", data.zipCode);
    updateField("unitNum", data.unit);
    updateField("community", data.community);
    updateField("gateCode", data.gateCode);
    updateField("phoneNum", data.phoneNum);
    updateField("email", data.email);
    updateField("jobNotes1", data.jobNotes1);
    updateField("jobNotes2", data.jobNotes2);
    updateField("jobNotes3", data.jobNotes3);
    updateField("jobNotes4", data.jobNotes4);
    updateField("jobNotes5", data.jobNotes5);
    updateField("jobNotes6", data.jobNotes6);
    updateField("jobNotes7", data.jobNotes7);
    updateField("comments1", data.comments1);
    updateField("comments2", data.comments2);
    updateField("customJobLabel", data.customJobLabel);
    updateField("customJobType", data.customJobType);
    updateField("estJobTime", data.estJobTime);
    updateField("eta", data.eta);
    updateField("jobType", data.jobType);
    updateField("paymentType", data.paymentType);
    updateField("plumberSelected", data.plumberSelected);
    updateField("selectedPlumbers", data.selectedPlumbers);
  };

  const capitalizeCustomJobType = (input) => {
    return input.charAt(0).toUpperCase() + input.slice(1);
  };

  function dismiss(length) {
    setTimeout(function () {
      clearInputs();
      setFlashbarSuccess([]);
      setResponseSuccessful("");
    }, length);
  }

  const putJobTicket = async (data, key) => {
    await axios
      .post(
        "https://api.hansoftware.net/putJobTicket",
        { data: data, DAUNKey: key },
        {
          headers: {
            Authorization: `Bearer ${authIDToken}`, // from Cognito login response
          },
        },
      )
      .then((response) => {
        const iso = new Date().toISOString();
        setTicketLoading(false);
        //console.log(response);
        //console.log(response.data.ResponseMetadata.HTTPStatusCode);
        if (response.data.ResponseMetadata.HTTPStatusCode === 200) {
          setFlashbarSuccess([
            {
              header: "Job ticket added successfully",
              type: "success",
              dismissible: true,
              dismissLabel: "Dismiss message",
              onDismiss: () => {
                setFlashbarSuccess([]);
                setResponseSuccessful("");
              },
            },
          ]);
          setResponseSuccessful(true);
          //dismiss(10000);
        } else {
          setTicketLoading(false);
          setFlashbarFail([
            {
              header: "Failed to add job ticket",
              type: "error",
              content:
                "There was an error when adding the Job Ticket." +
                " Please check your internet connection. If issue persists, please click the button to the right to send a report to the IT Staff. Thank you.",
              action: (
                <Button
                  href={
                    "mailto:hansoftwaredev@gmail.com?subject=CPS%20Error%20Report&body=Complete%Job%20Ticket%20" +
                    iso
                  }
                >
                  Send report
                </Button>
              ),
              dismissible: true,
              dismissLabel: "Dismiss message",
              onDismiss: () => {
                setFlashbarFail([]);
                setResponseSuccessful("");
              },
            },
          ]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const completeJobTicket = async () => {
    setTicketLoading(true);
    checkInputs();
    let key = "";
    if (state) {
      // ticket is being edited
      key = state.ticketData.key;
    }
    await putJobTicket(ticketData, key);
    dismiss(10000);
  };

  return (
    <Layout
      style={{
        overflow: "hidden",
        width: "100%",
        height: "calc(100vh - 60px)", // 60px is height of navbar
      }}
    >
      <style>{`
        .custom-dark-picker.ant-picker {
          border-color: #7d8998 !important;
          border-width: 1.8px !important;
          border-style: solid !important;
        }
        .custom-dark-picker.ant-picker:hover {
          border-color: #7d8998 !important;
        }
      `}</style>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div
          style={{
            height: 32,
            margin: 16,
            color: "white",
            fontSize: 18,
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {collapsed ? <MenuOutlined /> : "Menu"}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          onClick={handleMenuClick}
          defaultSelectedKeys={["/dashboard/ticket-generator"]}
          items={[
            {
              key: "/dashboard",
              icon: <PieChartOutlined />,
              label: "Dashboard",
            },
            {
              key: "/dashboard/job-board",
              icon: <DashboardOutlined />,
              label: "Job Board",
            },
            {
              key: "/dashboard/ticket-generator",
              icon: <PicLeftOutlined />,
              label: "Ticket Generator",
            },
            {
              key: "/dashboard/customer-list",
              icon: <UnorderedListOutlined />,
              label: "Customer List",
            },
          ]}
        />
      </Sider>
      <Layout
        style={{
          height: "calc(100vh + 100px)",
          backgroundColor: "#fff",
          paddingRight: 15,
        }}
      >
        <HeaderAnt style={{ background: "#fff", padding: "0 20px" }}>
          <h1 style={{ margin: 0 }}>Ticket Generator</h1>
        </HeaderAnt>
        <Grid
          gridDefinition={[
            // Left side taking up 8 out of 12 columns on large screens
            { colspan: { default: 12, l: 8 } },
            // Right static column taking up 4 out of 12 columns on large screens
            { colspan: { default: 12, l: 4 } },
          ]}
        >
          {/* Left Section: Scrollable wrapper containing 2 columns/containers */}
          <div
            style={{
              height: "calc(100vh - 130px)",
              overflowY: "auto",
              paddingRight: "12px",
              backgroundColor: "#fff",
            }}
          >
            <Grid
              gridDefinition={[
                { colspan: { default: 12, s: 6 } },
                { colspan: { default: 12, s: 6 } },
              ]}
            >
              <div style={{ paddingLeft: 10 }}>
                <SpaceBetween direction="vertical" size="s">
                  {/* Scrollable content for container 1 */}
                  <Container
                    fitHeight
                    header={<Header variant="h3">Date and Time</Header>}
                  >
                    <SpaceBetween direction="vertical" size="m">
                      <FormField
                        label="Call date"
                        constraintText="Example: 03/08/2024 or 4/3/24"
                        stretch
                      >
                        <DatePicker
                          className="custom-dark-picker"
                          style={{ width: "100%" }}
                          placeholder="Select call date"
                          format={"MM/DD/YY"}
                          onChange={handleCallDateChange}
                          value={
                            ticketData.callDate
                              ? dayjs(ticketData.callDate)
                              : null
                          }
                        />
                      </FormField>
                      <FormField
                        label="Scheduled job date"
                        constraintText="Example:  Friday 03/08/2024 or Wed 4/3/24"
                        stretch
                      >
                        <DatePicker
                          className="custom-dark-picker"
                          style={{ width: "100%" }}
                          placeholder="Select job date"
                          format={"dddd MM/D/YY"}
                          onChange={handleJobDateChange}
                          value={
                            ticketData.jobDate
                              ? dayjs(ticketData.jobDate)
                              : null
                          }
                        />
                      </FormField>
                      <FormField
                        label="Time frame (ETA)"
                        constraintText="Example: 9-10, 12-4, etc."
                        stretch
                        errorText={errEta}
                      >
                        <Input
                          onChange={({ detail }) => {
                            updateField("eta", detail.value);
                            validateEta(detail.value);
                          }}
                          value={ticketData.eta}
                          disabled={ticketData.jobType === "Product"}
                        />
                      </FormField>
                    </SpaceBetween>
                  </Container>
                  <Container
                    fitHeight
                    header={<Header variant="h3">Plumber Information</Header>}
                  >
                    <SpaceBetween direction="vertical" size="m">
                      <FormField label="Job type" stretch>
                        <RadioGroup
                          onChange={({ detail }) =>
                            updateField("jobType", detail.value)
                          }
                          value={ticketData.jobType}
                          items={[
                            {
                              value: "Service Call",
                              label: "Service Call",
                            },
                            { value: "Job View", label: "Job View" },
                            { value: "Product", label: "Product" },
                            { value: "Add-on", label: "Add-on" },
                            {
                              value: ticketData.customJobType,
                              label: ticketData.customJobLabel,
                            },
                          ]}
                        />
                      </FormField>
                      {ticketData.jobType !== "Service Call" &&
                      ticketData.jobType !== "Job View" &&
                      ticketData.jobType !== "Product" &&
                      ticketData.jobType !== "Add-on" ? (
                        <SpaceBetween direction="horizontal" size="xxs">
                          <FormField
                            constraintText="You MUST click 'Ok' for the job type to take effect"
                            errorText={
                              ticketData.customJobType.length > 12
                                ? "Too many characters. Keep it simple!"
                                : ""
                            }
                          >
                            <Input
                              onChange={({ detail }) => {
                                updateField("customJobType", detail.value);
                              }}
                              placeholder="Custom job type"
                              value={ticketData.customJobType}
                            />
                          </FormField>
                          <Button
                            onClick={() => {
                              updateField(
                                "customJobType",
                                capitalizeCustomJobType(
                                  ticketData.customJobType,
                                ),
                              );
                              updateField(
                                "jobType",
                                capitalizeCustomJobType(
                                  ticketData.customJobType,
                                ),
                              );
                              updateField(
                                "customJobLabel",
                                capitalizeCustomJobType(
                                  ticketData.customJobType,
                                ),
                              );
                            }}
                            disabled={ticketData.customJobType.length > 12}
                          >
                            Ok
                          </Button>
                        </SpaceBetween>
                      ) : (
                        ""
                      )}
                      <FormField
                        label="Plumber(s) assigned"
                        stretch
                        errorText={errPlumbers}
                      >
                        <Multiselect
                          selectedOptions={ticketData.selectedPlumbers}
                          onChange={({ detail }) => {
                            updateField("plumberSelected", true);
                            updateField(
                              "selectedPlumbers",
                              detail.selectedOptions,
                            );
                            validatePlumbers(detail.selectedOptions);
                          }}
                          options={[
                            {
                              label: "Bill Hanson",
                              value: "BH",
                            },
                            {
                              label: "Ed Skillen",
                              value: "ES",
                            },
                            {
                              label: "Jake Hanson",
                              value: "JH",
                            },
                          ]}
                          placeholder="Choose plumber(s)"
                        />
                      </FormField>
                      <SpaceBetween direction="vertical" size="m">
                        <SpaceBetween direction="horizontal" size="xxs">
                          <FormField
                            label="Estimated job completion time"
                            constraintText="Example: 1-2, 0.5-1, 2-4. Please choose 'hr' or 'hrs' to the right!"
                            stretch
                            errorText={errEstJobTime}
                          >
                            <SpaceBetween direction="horizontal" size="xxs">
                              <Input
                                onChange={({ detail }) => {
                                  updateField("estJobTime", detail.value);
                                  validateEstJobTime(detail.value);
                                }}
                                value={ticketData.estJobTime}
                                disabled={
                                  ticketData.jobType === "Job View" ||
                                  ticketData.jobType === "Product"
                                }
                              />
                              <Button
                                onClick={() => {
                                  updateField(
                                    "estJobTime",
                                    ticketData.estJobTime + " hr",
                                  );
                                  validateEstJobTime(
                                    ticketData.estJobTime + " hr",
                                  );
                                }}
                                disabled={ticketData.estJobTime !== "1"}
                              >
                                hr
                              </Button>
                              <Button
                                onClick={() => {
                                  updateField(
                                    "estJobTime",
                                    ticketData.estJobTime + " hrs",
                                  );
                                  validateEstJobTime(
                                    ticketData.estJobTime + " hrs",
                                  );
                                }}
                                disabled={
                                  ticketData.estJobTime === "1" ||
                                  ticketData.estJobTime.includes("hr") ||
                                  ticketData.estJobTime === ""
                                }
                              >
                                hrs
                              </Button>
                            </SpaceBetween>
                          </FormField>
                        </SpaceBetween>
                      </SpaceBetween>
                      <FormField
                        label="Payment type"
                        stretch
                        errorText={errPaymentType}
                      >
                        <RadioGroup
                          onChange={({ detail }) => {
                            updateField("paymentType", detail.value);
                            validatePaymentType(detail.value);
                          }}
                          value={ticketData.paymentType}
                          items={[
                            {
                              value: "ATS",
                              label: "At time of service",
                              disabled:
                                ticketData.jobType === "Job View" ||
                                ticketData.jobType === "Product",
                            },
                            {
                              value: "Check",
                              label: "Check",
                              disabled:
                                ticketData.jobType === "Job View" ||
                                ticketData.jobType === "Product",
                            },
                            {
                              value: "CC",
                              label: "Credit card",
                              disabled:
                                ticketData.jobType === "Job View" ||
                                ticketData.jobType === "Product",
                            },
                            {
                              value: "N/C",
                              label: "No charge",
                              disabled:
                                ticketData.jobType === "Job View" ||
                                ticketData.jobType === "Product",
                            },
                            {
                              value: "Office",
                              label: "Office",
                              disabled:
                                ticketData.jobType === "Job View" ||
                                ticketData.jobType === "Product",
                            },
                          ]}
                        />
                      </FormField>
                      <FormField
                        label="Job status"
                        stretch
                        errorText={errStatus}
                      >
                        <RadioGroup
                          onChange={({ detail }) => {
                            updateField("calendarStatus", detail.value);
                            validateStatus(detail.value);
                          }}
                          value={ticketData.calendarStatus}
                          items={[
                            {
                              value: "Scheduled",
                              label: (
                                <Badge status={"default"} text={"Scheduled"} />
                              ),
                            },
                            {
                              value: "In progress",
                              label: (
                                <Badge
                                  status={"warning"}
                                  text={"In progress"}
                                />
                              ),
                            },
                            {
                              value: "Complete",
                              label: (
                                <Badge status={"success"} text={"Complete"} />
                              ),
                            },
                            {
                              value: "Cancelled",
                              label: (
                                <Badge status={"error"} text={"Cancelled"} />
                              ),
                            },
                          ]}
                        />
                      </FormField>
                    </SpaceBetween>
                  </Container>
                </SpaceBetween>
              </div>

              <div style={{ paddingLeft: 5 }}>
                <SpaceBetween direction="vertical" size="s">
                  {/* Scrollable content for container 2 */}
                  <Container
                    fitHeight
                    header={<Header variant="h3">Customer Information</Header>}
                  >
                    <SpaceBetween direction="vertical" size="m">
                      <FormField label="Name" stretch>
                        <Input
                          onChange={({ detail }) =>
                            updateField("name", detail.value)
                          }
                          value={ticketData.name}
                          inputMode="text"
                        />
                      </FormField>
                      <FormField label="Address" stretch>
                        <Input
                          onChange={({ detail }) =>
                            updateField("address", detail.value)
                          }
                          value={ticketData.address}
                          disabled={ticketData.jobType === "Product"}
                        />
                      </FormField>
                      <FormField
                        label="Zip code"
                        stretch
                        errorText={errZipCode}
                      >
                        <Input
                          onChange={({ detail }) => {
                            updateField("zipCode", detail.value);
                            validateZipCode(detail.value);
                          }}
                          value={ticketData.zipCode}
                          disabled={ticketData.jobType === "Product"}
                        />
                      </FormField>
                      <FormField label="Unit #" stretch>
                        <Input
                          onChange={({ detail }) =>
                            updateField("unitNum", detail.value)
                          }
                          value={ticketData.unitNum}
                          disabled={ticketData.jobType === "Product"}
                        />
                      </FormField>
                      <FormField
                        label="Community, building, etc."
                        constraintText="Island Walk, Dorchester, etc."
                        stretch
                      >
                        <Input
                          onChange={({ detail }) =>
                            updateField("community", detail.value)
                          }
                          value={ticketData.community}
                          disabled={ticketData.jobType === "Product"}
                        />
                      </FormField>
                      <FormField
                        label="Gate code"
                        stretch
                        warningText={
                          gateCodeWarning && !ticketData.gateCode
                            ? "Confirm that address does not require gate code"
                            : ""
                        }
                      >
                        <Input
                          onChange={({ detail }) =>
                            updateField("gateCode", detail.value)
                          }
                          onFocus={setGateCodeWarning}
                          value={ticketData.gateCode}
                          disabled={ticketData.jobType === "Product"}
                        />
                      </FormField>
                      <FormField
                        label="Phone number"
                        constraintText="Example: 239-455-2295"
                        stretch
                        errorText={errPhone}
                      >
                        <Input
                          onChange={({ detail }) => {
                            updateField("phoneNum", detail.value);
                            validatePhone(detail.value);
                          }}
                          value={ticketData.phoneNum}
                          inputMode="tel"
                          disabled={ticketData.jobType === "Product"}
                        />
                      </FormField>
                      <FormField
                        label="Email address"
                        constraintText="Example: michaelknight@gmail.com"
                        stretch
                        errorText={errEmail}
                      >
                        <Input
                          onChange={({ detail }) => {
                            updateField("email", detail.value);
                            validateEmail(detail.value);
                          }}
                          value={ticketData.email}
                          inputMode="email"
                          disabled={ticketData.jobType === "Product"}
                        />
                      </FormField>
                      {ticketData.email.length > 0 ? (
                        <SpaceBetween direction="horizontal" size="s">
                          <Button
                            onClick={() => {
                              updateField(
                                "email",
                                ticketData.email + "@gmail.com",
                              );
                              validateEmail(ticketData.email + "@gmail.com");
                            }}
                          >
                            @gmail.com
                          </Button>
                          <Button
                            onClick={() => {
                              updateField(
                                "email",
                                ticketData.email + "@yahoo.com",
                              );
                              validateEmail(ticketData.email + "@yahoo.com");
                            }}
                          >
                            @yahoo.com
                          </Button>
                          <Button
                            onClick={() => {
                              updateField(
                                "email",
                                ticketData.email + "@hotmail.com",
                              );
                              validateEmail(ticketData.email + "@hotmail.com");
                            }}
                          >
                            @hotmail.com
                          </Button>
                          <Button
                            onClick={() => {
                              updateField(
                                "email",
                                ticketData.email + "@comcast.net",
                              );
                              validateEmail(ticketData.email + "@comcast.net");
                            }}
                          >
                            @comcast.net
                          </Button>
                          <Button
                            onClick={() => {
                              updateField(
                                "email",
                                ticketData.email + "@outlook.com",
                              );
                              validateEmail(ticketData.email + "@outlook.com");
                            }}
                          >
                            @outlook.com
                          </Button>
                          <Button
                            onClick={() => {
                              updateField(
                                "email",
                                ticketData.email + "@icloud.com",
                              );
                              validateEmail(ticketData.email + "@icloud.com");
                            }}
                          >
                            @icloud.com
                          </Button>
                          <Button
                            onClick={() => {
                              updateField(
                                "email",
                                ticketData.email + "@aol.com",
                              );
                              validateEmail(ticketData.email + "@aol.com");
                            }}
                          >
                            @aol.com
                          </Button>
                        </SpaceBetween>
                      ) : (
                        ""
                      )}
                    </SpaceBetween>
                  </Container>
                  <Container
                    fitHeight
                    header={<Header variant="h3">Notes</Header>}
                  >
                    <SpaceBetween direction="vertical" size="m">
                      <SpaceBetween direction="vertical" size="xxs">
                        <FormField
                          label="Job Notes"
                          stretch
                          warningText={
                            ticketData.jobNotes1.length > 22
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("jobNotes1", detail.value)
                            }
                            value={ticketData.jobNotes1}
                            placeholder="Job notes line 1"
                          />
                        </FormField>
                        <FormField
                          stretch
                          warningText={
                            ticketData.jobNotes2.length > 27
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("jobNotes2", detail.value)
                            }
                            value={ticketData.jobNotes2}
                            placeholder="Job notes line 2"
                          />
                        </FormField>
                        <FormField
                          stretch
                          warningText={
                            ticketData.jobNotes3.length > 27
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("jobNotes3", detail.value)
                            }
                            value={ticketData.jobNotes3}
                            placeholder="Job notes line 3"
                          />
                        </FormField>
                        <FormField
                          stretch
                          warningText={
                            ticketData.jobNotes4.length > 27
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("jobNotes4", detail.value)
                            }
                            value={ticketData.jobNotes4}
                            placeholder="Job notes line 4"
                          />
                        </FormField>
                        <FormField
                          stretch
                          warningText={
                            ticketData.jobNotes5.length > 27
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("jobNotes5", detail.value)
                            }
                            value={ticketData.jobNotes5}
                            placeholder="Job notes line 5"
                          />
                        </FormField>
                        <FormField
                          stretch
                          warningText={
                            ticketData.jobNotes6.length > 27
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("jobNotes6", detail.value)
                            }
                            value={ticketData.jobNotes6}
                            placeholder="Job notes line 6"
                            spellcheck
                          />
                        </FormField>
                        <FormField
                          stretch
                          warningText={
                            ticketData.jobNotes7.length > 27
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("jobNotes7", detail.value)
                            }
                            value={ticketData.jobNotes7}
                            placeholder="Job notes line 7"
                            spellcheck
                          />
                        </FormField>
                      </SpaceBetween>
                      <SpaceBetween direction="vertical" size="xxs">
                        <FormField
                          label="Office Comments"
                          stretch
                          warningText={
                            ticketData.comments1.length > 21
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("comments1", detail.value)
                            }
                            value={ticketData.comments1}
                            placeholder="Office notes line 1"
                          />
                        </FormField>
                        <FormField
                          stretch
                          warningText={
                            ticketData.comments2.length > 27
                              ? "Text size will be reduced due to character count"
                              : ""
                          }
                        >
                          <Input
                            onChange={({ detail }) =>
                              updateField("comments2", detail.value)
                            }
                            value={ticketData.comments2}
                            placeholder="Office notes line 2"
                          />
                        </FormField>
                      </SpaceBetween>
                      {autofillNotes !== "" ? (
                        <FormField
                          label="Notes from Autofill (read only)"
                          stretch
                        >
                          <Textarea
                            onChange={({ detail }) =>
                              setAutofillNotes(detail.value)
                            }
                            value={autofillNotes}
                            readOnly
                          />
                        </FormField>
                      ) : (
                        ""
                      )}
                    </SpaceBetween>
                  </Container>
                </SpaceBetween>
              </div>
            </Grid>
          </div>

          {/* Right Section: Static Column */}
          <Container
            header={
              <SpaceBetween direction="vertical" size="s">
                {ticketLoading ? (
                  <Flashbar
                    items={[
                      {
                        type: "info",
                        loading: true,
                        content: "Ticket is being submitted, please wait.",
                        dismissible: false,
                      },
                    ]}
                  />
                ) : (
                  ""
                )}
                {responseSuccessful === true ? (
                  <Flashbar items={flashbarSuccess} />
                ) : (
                  ""
                )}
                {responseSuccessful === false ? (
                  <Flashbar items={flashbarFail} />
                ) : (
                  ""
                )}

                <SpaceBetween direction="horizontal" size="s">
                  <Header variant="h2">Job Ticket Preview</Header>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      margin: "0 auto",
                    }}
                  >
                    <Button
                      fullWidth
                      variant="primary"
                      onClick={() => {
                        completeJobTicket();
                      }}
                      loading={ticketLoading}
                    >
                      {state
                        ? state.from === "job-board"
                          ? "Finish Changes"
                          : "Complete Job Ticket"
                        : "Complete Job Ticket"}
                    </Button>
                  </div>
                </SpaceBetween>
              </SpaceBetween>
            }
            style={{
              paddingRight: 10,
            }}
          >
            {/* Static content that stays in place */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "50%",
                margin: "0 auto",
              }}
            >
              <SpaceBetween direction="vertical" size="s">
                <TicketCanvas data={ticketData} />
              </SpaceBetween>
            </div>
          </Container>
        </Grid>
      </Layout>
    </Layout>
  );
}

export default TicketGenerator;
